import { useEffect, useRef, useState } from "react";
import {
  GetDeviceByFilter,
  AddDeviceApi,
  DeviceData,
  UdateDeviceApi,
  CheckDeviceUpdateStatusApi,
  GetAllOrg,
  GetAllVersions,
  UpdateDeviceOrgApi,
} from "../Api";
import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Snackbar,
  Typography,
  // LinearProgress,
  TextField,
  useTheme,
  useMediaQuery,
  Input,
  Dialog,
  DialogContent,
} from "@mui/material";
import DataTable from "react-data-table-component";
import DeviceDetailSlider from "../DeviceDetailSlider";
import AddDeviceModal, { Tag } from "./AddDeviceModal";
import Spinner from "../Spinner";
import TimelineWithPicker from "../components/TimelineWithPicker";
// import SettingsIcon from '@mui/icons-material/Settings'
import SettingPage from "./SettingPage";

interface Props {
  isWithOrg: boolean;
}

export default function DeviceDataList({ isWithOrg }: Props) {
  const isLoading = useRef(true);
  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [addDevice, setAddDevice] = useState<DeviceData>({
    // installationTime: "",
    // location: "",
    organization: "",
    firmwareVersion: "",
    mac_address: "",
    tags: [],
    deviceType: "",
  });
  const [updateDevice, setUpdateDevice] = useState<any>();
  const [updateModal, setUpdateModal] = useState<any>();
  const [versions, setVersions] = useState<any>();
  const [newVersion, setNewVersion] = useState<string>("");
  const [selectedVersion, setSelectecVersion] = useState<any>();
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({ open: false, message: "", severity: "success" });
  const [versionWarning, setVersionWarning] = useState<string>("");

  const [overAllDeviceCount, setOverAllDeviceCount] = useState(0);
  const [overAllConnectedCount, setOverAllConnectedCount] = useState(0);
  // const [snackbar, setSnackbar] = useState<{
  //   open: boolean;
  //   message: string;
  //   severity: "success" | "error";
  // }>({ open: false, message: "", severity: "success" });

  const [selectedDevice, setSelectedDevice] = useState<any>(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);

  const [organizations, setOrganizations] = useState<any>();
  const [spinner, setSpinner] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0); // 👈 for paginationTotalRows
  const [page, setPage] = useState<number>(1); // current page
  const [limit, setLimit] = useState<number>(10); // per-page limit
  const [search, setSearch] = useState<string>(""); // for search const [totalPages, setTotalPages] = useState<number>(1);
  const [allDevices, setAllDevices] = useState<any[]>([]);
  // const [filteredDevices, setFilteredDevices] = useState<any[]>([]);
  const [updateOrgModal, setUpdateOrgModal] = useState<boolean>(false);
  const [updateOrg, setUpdateOrg] = useState<string>("");

  const [tags, setTags] = useState<Tag[]>([]);
  const [deviceStatusModal, setDeviceStatusModal] = useState<boolean>(false);
  const [addFieldsModal, setAddFieldsModal] = useState<boolean>(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState<"success" | "error">(
    "success"
  );

  const copyEncryptionKey = (key: string) => {
    navigator.clipboard
      .writeText(key)
      .then(() => {
        setToastMessage("Key copied successfully!");
        setToastSeverity("success");
        setShowToast(true);
      })
      .catch((e) => {
        setToastMessage("Failed to copy key");
        setToastSeverity("error");
        setShowToast(true);
      });
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleLimitChange = (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage); // reset page when limit changes
  };
  const handleTagChange = (index: number, field: keyof Tag, value: string) => {
    const newTags = [...tags];
    newTags[index][field] = value;
    setTags(newTags);
    setAddDevice({ ...addDevice, tags: newTags });
  };

  const addTag = () => {
    const newTags = [...tags, { key: "", value: "" }];
    setTags(newTags);
    setAddDevice({ ...addDevice, tags: newTags });
  };

  const removeTag = (index: number) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    setAddDevice({ ...addDevice, tags: newTags });
  };

  const getOrgAndVersionsList = async () => {
    const versionsResult = await GetAllVersions();
    setVersions(versionsResult);
    const org = await GetAllOrg();
    // const org = await ();
    setOrganizations(org);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getOrgAndVersionsList();
      fetchData(); // fetch every 10 seconds
    }, 10000);

    return () => clearInterval(interval); // cleanup on unmount or dependency change
  }, [search, page, limit, isWithOrg]);
  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchData(); // wait for API call
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, [search, page, limit]);

  useEffect(() => {
    if (parentRef.current) {
      var parentCurrent: any = parentRef.current;
      setParentWidth(parentCurrent?.clientWidth);
    }
  }, [parentRef]);

  async function fetchData() {
    if (isLoading.current) {
      setSpinner(true);
      // const org = await GetAllOrg();
      // setOrganizations(org)

      // const versionsResult = await GetAllVersions();
      // setVersions(versionsResult);
    }
    try {
      const result: any = await GetDeviceByFilter({
        page,
        limit,
        search,
        orgFilter: isWithOrg ? "true" : "false",
      });
     
      // let filterWithoutOrg;
      // if (isWithOrg) {
      //   filterWithoutOrg = result.devices.filter((obj: any) =>
      //     obj.organization ? obj.organization !== "" : false
      //   );
      // } else {
      //   filterWithoutOrg = result.devices.filter((obj: any) =>
      //     obj.organization ? obj.organization === "" : true
      //   );
      // }

      // Store all devices
      setAllDevices(result.devices);
      setTotalCount(result.total); // 👈 update total count from backend
      setOverAllDeviceCount(result.overAllDeviceCount ?? 0);
      setOverAllConnectedCount(result.overAllConnectedCount ?? 0);
      // Apply search filter
      // applySearchFilter(filterWithoutOrg);

      isLoading.current = false;
      setSpinner(false);
    } catch (error) {
      isLoading.current = false;
      setSpinner(false);
    }
  }

  // const applySearchFilter = (devices: any[]) => {
  //   const filtered = devices.filter((obj: any) =>
  //     [
  //       obj.deviceID,
  //       obj.mac_address,
  //       obj.firmwareVersion,
  //       obj.tags?.join(" "),
  //       obj.organization,
  //     ].some((value) =>
  //       value?.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  //   );
  //   setFilteredDevices(filtered);
  // };

  // useEffect(() => {
  //   applySearchFilter(allDevices);
  // }, [searchQuery, allDevices]);

  const handleViewClick = (device: any) => {
    setSelectedDevice(device);
    setDeviceStatusModal(true);
  };

  const col = [
    {
      name: "Device Id",
      selector: (row: any) => row?.deviceID,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.deviceID}
        </div>
      ),
    },
    {
      name: "Device Mac Address",
      selector: (row: any) => row?.mac_address,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.mac_address}
        </div>
      ),
    },
    {
      name: "Installation Time",
      selector: (row: any) => row?.installationTime,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.installationTime}
        </div>
      ),
    },
    {
      name: "Firmware Version",
      selector: (row: any) => row?.firmwareVersion,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.firmwareVersion}
        </div>
      ),
    },
    {
      name: "Organization",
      selector: (row: any) => row?.organization,
      cell: (row: any) =>
        isWithOrg ? (
          <div
            style={{
              whiteSpace: "normal",
              overflow: "visible",
              textOverflow: "clip",
              cursor: "pointer",
            }}
            onClick={() => {
              setSelectedDevice(row);
              setIsSliderOpen(true);
            }}
          >
            {row?.organization}
          </div>
        ) : (
          <Button
            onClick={() => {
              setUpdateDevice(row);
              setTags(row?.tags || []);
              setSelectecVersion(row);
              setUpdateOrgModal(true);
              // UpdateVersionfileData(row.version);
            }}
          >
            Add
          </Button>
        ),
    },
    {
      name: "Device Status",
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            cursor: "pointer",
            color: row?.deviceStatus ? "green" : "black",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          onClick={() => {
            // setSelectedDevice(row);
            // setIsSliderOpen(true);
          }}
        >
          <div>{row?.deviceStatus === true ? "Connected" : "Disconnected"}</div>
          {/* <Button
            variant="text"
            size="small"
            onClick={() => handleViewClick(row)}
          >
            View
          </Button> */}
        </div>
      ),
    },
    // {
    //   name: "Disconnected Time",
    //   selector: (row: any) =>
    //     row?.deviceStatus === true ? "" : row?.disconnectTime,
    //   cell: (row: any) => (
    //     <div style={{ whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }} onClick={() => {
    //       setSelectedDevice(row);
    //       setIsSliderOpen(true);
    //     }}>
    //       {row?.installationTime}
    //     </div>),
    // },
    // {
    //   name: "Progress",
    //   selector: (row: any) =>
    //     row?.deviceStatus === true ? "" : row?.updateProgress,
    //   cell: (row: any) => (
    //     <Box width={"100%"}>
    //       <LinearProgress
    //         variant="determinate"
    //         value={row?.updateProgress || 0}
    //         style={{ width: "100%", marginBottom: "5px" }}
    //       />
    //       <Typography
    //         variant="body2"
    //         color="textSecondary"
    //         style={{ textAlign: "center" }}
    //       >
    //         {`${row?.updateProgress || 0}%`}
    //       </Typography>
    //     </Box>
    //   ),
    // },
    {
      name: "Update Firmware",
      cell: (row: any) => (
        <Button
          // disabled={!row?.deviceStatus}
          onClick={() => {
            // console.log("row: ", row);
            setVersionWarning("");
            setUpdateDevice(row);
            setSelectecVersion(row);
            setUpdateModal(true);
            setSelectedDevice(row);
            // UpdateVersionfileData(row.version);
          }}
        >
          Update
        </Button>
      ),
    },
    {
      name: "Update Status",
      selector: (row: any) => row?.updateStatus,
      cell: (row: any) => (
        <div
          style={{
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedDevice(row);
            setIsSliderOpen(true);
          }}
        >
          {row?.updateStatus === "not-started" ? (
            <></>
          ) : (
            <p>{row?.updateProgress}%</p>
          )}
          <p>{row?.updateStatus === "not-started" ? "" : row?.updateStatus}</p>
        </div>
      ),
    },
  ];

  const HandleAddData = () => {
    setOpenModal(true);
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    p: 4,
  };

  const submitAddDevice = async () => {
    try {
      if (
        addDevice?.firmwareVersion !== "" ||
        addDevice?.mac_address !== "" ||
        addDevice?.organization !== "" ||
        addDevice?.deviceType !== ""
      ) {
        const res = await AddDeviceApi(addDevice);
        setOpenModal(false);
        fetchData();
        if (res.code !== "ok") {
          setSnackbar({
            open: true,
            message: "Error on Submit Data",
            severity: "error",
          });
        }
      } else {
        setSnackbar({
          open: true,
          message: "Please fill all details",
          severity: "error",
        });
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const updateDeviceVersion = async (
    version: string,
    deviceID: string,
    deviceType: string
  ) => {
    // const hostname = window.location.origin;
    const data = {
      deviceID: deviceID,
      version: version,
      url: `${window.location.host}/file/download?deviceType=${deviceID}&path=${version}`, // Do not send http or https
    };

    try {
      const res = await UdateDeviceApi(data);

      if (res.code !== "ok") {
        setSnackbar({
          open: true,
          message: "Error on Update Device",
          severity: "error",
        });
        return;
      }

      setSnackbar({
        open: true,
        message: "Update Started successfully",
        severity: "success",
      });

      const checkUpdateStatus = async () => {
        try {
          const device = await CheckDeviceUpdateStatusApi(deviceID);
          await fetchData();
          if (
            device.updateStatus.includes("Firmware version updated to") ||
            device.updateStatus === "update-failed"
          ) {
            clearInterval(intervalId); // Stop the interval
            const message = device.updateStatus.includes(
              "Firmware version updated to"
            )
              ? "Firmware updated successfully"
              : "Firmware update failed";
            setSnackbar({
              open: true,
              message,
              severity: device.updateStatus.includes("update-failed")
                ? "error"
                : "success",
            });
          } else if (
            device.updateStatus === "Download link received by device"
          ) {
            setSnackbar({
              open: true,
              message: "Download link received by device",
              severity: "success",
            });
          } else if (device.updateStatus === "Downloaded successfully") {
            setSnackbar({
              open: true,
              message: "Downloaded update successfully",
              severity: "success",
            });
          } else if (device.updateStatus === "update-failed on device side") {
            setSnackbar({
              open: true,
              message: "Update failed on device side",
              severity: "error",
            });
            clearInterval(intervalId); // Stop the interval
          }
        } catch (error) {
          console.error("Error checking update status:", error);
        }
      };

      const intervalId = setInterval(checkUpdateStatus, 2000); // Check every 5 seconds

      // Optional: Stop checking after a maximum amount of time or retries
      setTimeout(() => clearInterval(intervalId), 60000); // Stop after 1 minute
    } catch (error) {
      console.error("Error updating device version:", error);
      setSnackbar({
        open: true,
        message: "Error on Update Device",
        severity: "error",
      });
    }
  };

  const UpdateVersionfileData = async (v: any) => {
    if (v !== "") {
      setNewVersion(v);
      const data = versions?.find(
        (obj: any) =>
          obj?.version === v && obj?.deviceID === selectedDevice?.deviceID
      );
      const versionStatus = compareVersions(selectedDevice?.firmwareVersion, v);
      if (versionStatus === "equal") {
        setSnackbar({
          open: true,
          message: "Device is already on this version: " + v,
          severity: "error",
        });
        setVersionWarning("Device is already on this version");
      } else if (versionStatus === "lower") {
        setVersionWarning(
          "The device will be downgraded to the selected version."
        );
        setSnackbar({
          open: true,
          message: "The device will be downgraded to the selected version.",
          severity: "error",
        });
      } else {
        setVersionWarning("");
      }
      setSelectecVersion(data);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const updateDeviceOrg = async (updateOrg: string, deviceID: string) => {
    // const hostname = window.location.origin;
    const data = {
      deviceID: deviceID,
      updateOrg: updateOrg,
      tags: tags,
    };

    try {
      const res = await UpdateDeviceOrgApi(data);

      if (res.code !== "ok") {
        setSnackbar({
          open: true,
          message: "Error on Update Organization",
          severity: "error",
        });
        return;
      }
      setSnackbar({
        open: true,
        message: "Organization updated",
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating device Org:", error);
    }
  };

  // const totalDevices = Array.isArray(allDevices) ? allDevices.length : 0;
  // const connectedDevices = Array.isArray(allDevices)
  //   ? allDevices.filter((d) => d?.deviceStatus).length
  //   : 0;

  function compareVersions(current: string, selected: string) {
    // Remove 'v' if it exists
    const currentParts = current.replace(/^v/, "").split(".").map(Number);
    const selectedParts = selected.replace(/^v/, "").split(".").map(Number);

    for (let i = 0; i < 3; i++) {
      const cur = currentParts[i] || 0;
      const sel = selectedParts[i] || 0;

      if (sel > cur) return "greater";
      if (sel < cur) return "lower";
    }

    return "equal";
  }

  const handleCloseToast = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setShowToast(false);
  };

  return (
    <>
      <Box sx={{ fontFamily: "Arial, sans-serif", p: 2 }}>
        <Spinner running={spinner} />
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            gap: 2,
          }}
          flexDirection={"column"}
          ref={parentRef}
        >
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"1rem"}
          >
            <Box>
              <Typography fontSize={isMobile ? "0.8rem" : "1rem"}>
                Connected: <strong>{overAllConnectedCount}</strong>/
                <strong>{overAllDeviceCount}</strong>
              </Typography>
            </Box>
            <Box
              display={"flex"}
              flexDirection={isMobile ? "column" : "row"}
              alignItems={"center"}
              gap={"1rem"}
              width={isMobile ? "100%" : "auto"}
            >
              <Input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                style={{
                  width: isMobile || isTablet ? "100%" : "250px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              />
              <Button
                sx={{
                  width: isMobile || isTablet ? "100%" : "auto",
                }}
                size={isMobile || isTablet ? "small" : "medium"}
                variant="contained"
                onClick={() => HandleAddData()}
              >
                Add Device Data
              </Button>
            </Box>
          </Grid>

          <div
            style={{
              flex: 1,
              width: parentWidth,
            }}
          >
            <DataTable
              columns={col}
              data={allDevices}
              pagination
              paginationServer
              paginationTotalRows={totalCount} // total from backend
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleLimitChange}
              paginationPerPage={limit}
              paginationDefaultPage={page}
              style={{ height: "70vh", width: "0vh !important" }}
              customStyles={{
                rows: {
                  style: {
                    overflow: "visible", // Ensure rows are not clipped
                  },
                },
                cells: {
                  style: {
                    whiteSpace: "normal", // Allows text to wrap
                    overflow: "visible", // Ensures text is visible
                  },
                },
              }}
            />
          </div>
          <AddDeviceModal
            addDevice={addDevice}
            submitAddDevice={submitAddDevice}
            openModal={openModal}
            setOpenModal={setOpenModal}
            organizations={organizations}
            setAddDevice={setAddDevice}
          />
          <Modal
            open={updateModal}
            onClose={() => {
              setUpdateModal(false);
              setSelectecVersion({});
              setNewVersion("");
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box component="form" sx={style} noValidate autoComplete="off">
              <Box
                sx={{
                  minWidth: 120,
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  flexDirection: "column",
                  minHeight: "300px",
                }}
              >
                <Typography variant="h5" padding="0px 0px 20px 0px">
                  Select Firmware Version
                </Typography>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Version
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={newVersion}
                    label="Select Version"
                    onChange={(e) => {
                      // keep your update call
                      UpdateVersionfileData(e.target.value);
                    }}
                  >
                    {!versions ? (
                      <MenuItem value={""}>{"Loading..."}</MenuItem>
                    ) : versions.filter(
                        (data: any) =>
                          data.deviceID === selectedDevice?.deviceID
                      ).length === 0 ? (
                      <MenuItem value={""}>{"No data available"}</MenuItem>
                    ) : (
                      versions
                        .filter(
                          (data: any) =>
                            data.deviceID === selectedDevice?.deviceID
                        )
                        .map((data: any) => (
                          <MenuItem key={data.version} value={data.version}>
                            {`${data.version}   -   ${data.uploadTime}`}
                          </MenuItem>
                        ))
                    )}
                  </Select>
                </FormControl>
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Version"
                      secondary={selectedVersion?.version}
                    />
                  </ListItem>
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Update Time"
                      secondary={selectedVersion?.uploadTime}
                    />
                  </ListItem>
                  {/* <ListItem sx={{ flex: "50%" }}>
                  <ListItemText
                    primary="Device Type"
                    secondary={selectedVersion?.deviceType}
                  />
                </ListItem> */}
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Device ID"
                      secondary={selectedVersion?.deviceID}
                    />
                  </ListItem>
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Description"
                      secondary={selectedVersion?.description}
                    />
                  </ListItem>
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Last Modified"
                      secondary={selectedVersion?.lastModified}
                    />
                  </ListItem>
                  <ListItem sx={{ flex: "50%" }}>
                    <ListItemText
                      primary="Size"
                      secondary={selectedVersion?.size}
                    />
                  </ListItem>
                </Box>
                {versionWarning && (
                  <Typography style={{ color: "blue" }}>
                    {versionWarning}
                  </Typography>
                )}
              </Box>
              <Grid container justifyContent={"end"}>
                <Button
                  color="secondary"
                  variant="contained"
                  style={{ marginTop: "50px" }}
                  onClick={() => setUpdateModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  style={{ marginLeft: "20px", marginTop: "50px" }}
                  disabled={!newVersion}
                  onClick={() => {
                    if (newVersion !== updateDevice?.firmwareVersion) {
                      updateDeviceVersion(
                        newVersion,
                        updateDevice.deviceID,
                        updateDevice.deviceType
                      );
                      setUpdateModal(false);
                    } else {
                      setSnackbar({
                        open: true,
                        message:
                          "Device is already on this version: " + newVersion,
                        severity: "error",
                      });
                    }
                  }}
                >
                  Update
                </Button>
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={updateOrgModal}
            onClose={() => setUpdateOrgModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box component="form" sx={style} noValidate autoComplete="off">
              <Box
                sx={{
                  minWidth: 120,
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  flexDirection: "column",
                  minHeight: "300px",
                }}
              >
                <Typography variant="h5" padding="0px 0px 20px 0px">
                  Update Device With Organization
                </Typography>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Organization
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={updateOrg}
                    label="Select Organization"
                    onChange={(v) => setUpdateOrg(v.target.value)}
                  >
                    {organizations?.map((data: any) => {
                      return (
                        <MenuItem key={data.name} value={data.id}>
                          {data.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <Typography variant="h6" padding="20px 0px">
                    Tags
                  </Typography>
                  {tags.map((tag, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <TextField
                        label="Key"
                        value={tag.key}
                        onChange={(e) =>
                          handleTagChange(index, "key", e.target.value)
                        }
                        sx={{ flex: 1, marginRight: "10px" }}
                      />
                      <TextField
                        label="Value"
                        value={tag.value}
                        onChange={(e) =>
                          handleTagChange(index, "value", e.target.value)
                        }
                        sx={{ flex: 1, marginRight: "10px" }}
                      />
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => removeTag(index)}
                      >
                        Remove
                      </Button>
                    </Box>
                  ))}
                  <Button
                    variant="contained"
                    onClick={addTag}
                    sx={{ marginBottom: "20px" }}
                  >
                    Add Tag
                  </Button>
                </FormControl>
              </Box>
              <Grid container justifyContent={"end"}>
                <Button
                  color="secondary"
                  variant="contained"
                  style={{ marginTop: "50px" }}
                  onClick={() => setUpdateOrgModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  style={{ marginLeft: "20px", marginTop: "50px" }}
                  onClick={async () => {
                    if (updateOrg !== "") {
                      await updateDeviceOrg(updateOrg, updateDevice.deviceID);
                      setUpdateOrgModal(false);
                    }
                  }}
                >
                  Update
                </Button>
              </Grid>
            </Box>
          </Modal>
          {/* Modal for check Timeline status */}
          <Dialog
            open={deviceStatusModal}
            onClose={() => setDeviceStatusModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogContent
              sx={{ padding: { xs: "20px 10px", md: "20px 24px" } }}
            >
              <Box sx={{ minHeight: "500px" }}>
                <TimelineWithPicker selectedDevice={selectedDevice} />
              </Box>
            </DialogContent>
          </Dialog>
          {/* Modal for add fields  */}
          <Dialog
            open={addFieldsModal}
            onClose={() => setAddFieldsModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogContent
              sx={{
                padding: {
                  xs: "20px 10px",
                  md: "20px 24px",
                  maxHeight: "75vh",
                  minHeight: "75vh",
                },
              }}
            >
              <Box sx={{ minHeight: "500px" }}>
                <SettingPage selectedDevice={selectedDevice} />
              </Box>
            </DialogContent>
          </Dialog>
          <Snackbar
            open={snackbar.open}
            autoHideDuration={5000}
            onClose={handleCloseSnackbar}
            message={snackbar.message}
            action={
              <Button color="inherit" onClick={handleCloseSnackbar}>
                Close
              </Button>
            }
          >
            <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Grid>
        <DeviceDetailSlider
          open={isSliderOpen}
          onClose={() => setIsSliderOpen(false)}
          device={selectedDevice}
          setSelectedDevice={setSelectedDevice}
          setSnackbar={setSnackbar}
          copyEncryptionKey={copyEncryptionKey}
        />
      </Box>
      <Snackbar
        open={showToast}
        autoHideDuration={3000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
